export enum TaskPhaseTagColors {
    BEFORE = '#F3E8FF',
    DURING = '#DBEAFE',
    AFTER = '#DCFCE7',

    BEFORE_TEXT = '#6D28D9',
    DURING_TEXT = '#1D4ED8',
    AFTER_TEXT = '#15803D'
}